import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';

const ControlBase = () => {

    const navigate = useNavigate();
    useEffect(()=>{
        localStorage.clear();
        navigate("/controlbase/login")

    },[])
  return (
    <div>ControlBase</div>
  )
}

export default ControlBase